import { isValidVRN, PrimaryButton, VehicleRegistrationInput } from '@wrisk/ui-components'
import React, { FunctionComponent, useCallback, useMemo, useState } from 'react'

import {
  TKey,
  useWriskTranslation,
} from '../../../../../infrastructure/internationalisation'
import { getFormats, useConfig } from '../../../../../state/configuration'

interface VehicleLookupInputProps {
  loading: boolean
  value?: string
  onSearch: (vrn: string) => void
}

const tKey = TKey('components.vehicle-lookup')

export const VehicleLookupInput: FunctionComponent<VehicleLookupInputProps> = ({
  value: valueProp,
  loading,
  onSearch,
}) => {
  const { t } = useWriskTranslation()
  const { vehicleRegistration } = useConfig(getFormats)

  const [value, setValue] = useState(valueProp ?? '')
  const disabled = useMemo(() => !isValidVRN(vehicleRegistration)(value), [value])

  const onSubmit = useCallback(() => {
    if (!disabled) onSearch(value)
  }, [disabled, onSearch, value])

  return (
    <VehicleRegistrationInput
      name='vehicleRegistration'
      onChange={setValue}
      onSubmit={onSubmit}
      placeholder={t<string>(tKey('placeholder'))}
      value={value}
      format={vehicleRegistration}
    >
      <PrimaryButton
        data-testid='vehicle-search'
        disabled={disabled}
        loading={loading}
        layout='small'
        whiteSpace='nowrap'
        onClick={onSubmit}
      >
        {t(tKey('actions.search'))}
      </PrimaryButton>
    </VehicleRegistrationInput>
  )
}
